import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../app.settings';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { RestApiService } from '../../services/rest-api.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html'
})
export class DownloadComponent implements OnInit {

  fileId = '';
  labelDownload = '';
  fileType = '';
  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private restApiService: RestApiService,
    private storageService: StorageService
  ) {
    this.labelDownload = this.commonBindingDataService.getLabel('label_download');
    activatedRoute.params.subscribe(params => {
      this.fileType = 'excel';
      this.fileId = params.fileId;
    });

    if (this.fileId === '' && this.storageService.getItem(AppSettings.TOKEN_KEY)) {
      this.router.navigate(['/sign- in']);
    }
  }

  ngOnInit() {
    // this.downloadFile();
  }

  downloadFile() {
    const url = `/secure/file-export/${this.fileId}`;
    this.restApiService.excelDownloadLink(url, 'export.xls', 'page-center');
  }

}
